import TechnologyList from './TechnologyList'

export default TechnologyList
